import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Star, Loader2 } from "lucide-react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const FeaturedMaestroAdmin = () => {
  const [data, setData] = useState(null);
  const [bid, setBid] = useState("");
  const [blurb, setBlurb] = useState("");
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/admin/featured-maestro").then(({ data }) => {
    setData(data); setBid(data.current?.business_id || ""); setBlurb(data.current?.blurb || "");
  });
  useEffect(() => { load(); }, []);
  const run = async (fn, ok) => {
    setBusy(true);
    try { await fn(); toast.success(ok); load(); }
    catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  const currentName = data?.options.find((o) => o.id === data.current?.business_id)?.name;

  return (
    <Card className="p-5" data-testid="featured-maestro-admin">
      <h3 className="font-bold flex items-center gap-2 mb-1"><Star className="w-5 h-5 text-primary" />Maestro de la Semana</h3>
      <p className="text-sm text-muted-foreground mb-4">
        Se muestra en la portada. Solo aparecen Maestros con talleres publicados y sin denuncias abiertas; si deja de cumplirlo, se oculta solo.
        {" "}Actual: <strong data-testid="featured-current">{currentName || "ninguno"}</strong>.
      </p>
      {!data ? <Loader2 className="w-5 h-5 animate-spin text-primary" /> : (
        <div className="space-y-3">
          <Select value={bid} onValueChange={setBid}>
            <SelectTrigger data-testid="featured-select"><SelectValue placeholder="Elige un Maestro" /></SelectTrigger>
            <SelectContent>{data.options.map((o) => <SelectItem key={o.id} value={o.id}>{o.name}{o.commune ? ` · ${o.commune}` : ""}</SelectItem>)}</SelectContent>
          </Select>
          <Textarea rows={3} maxLength={400} value={blurb} onChange={(e) => setBlurb(e.target.value)}
            placeholder="Su historia en pocas palabras (opcional)" data-testid="featured-blurb" />
          <div className="flex justify-end gap-2">
            {data.current && <Button variant="ghost" disabled={busy} onClick={() => run(() => api.delete("/admin/featured-maestro"), "Se quitó el Maestro de la Semana")} data-testid="featured-clear">Quitar</Button>}
            <Button disabled={busy || !bid} onClick={() => run(() => api.put("/admin/featured-maestro", { business_id: bid, blurb }), "Maestro de la Semana actualizado")} data-testid="featured-save">
              {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : "Guardar"}
            </Button>
          </div>
        </div>
      )}
    </Card>
  );
};
